module.exports = __webpack_public_path__ + "media/components/Bazaarvoice/icons/close-icon-97407a1136643e11843465e3cbd8129c.svg";